/* unplugin-vue-components disabled */import script from "./Score.vue?vue&type=script&setup=true&lang=js"
export * from "./Score.vue?vue&type=script&setup=true&lang=js"

import "./Score.vue?vue&type=style&index=0&id=39feb700&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39feb700"]])

export default __exports__